<template>
  <div>
    <p class="ma-0 font-weight-medium">
        {{coluna.texto}}
    </p>

    <p class="ma-0 mt-n1">
      <template v-if="detalhamento_categoria.ressuprimento_em_dias !== '-'">
        {{`${Helpers.formatarValor(detalhamento_categoria.ressuprimento_em_dias)} dias`}}
        <v-icon small class="mt-n1" @click="dialog_ativo = true">mdi-pencil</v-icon>
      </template>
      <template v-else>-</template>
    </p>

    <v-dialog
      v-model="dialog_ativo"
      width="450"
      content-class="bra-20"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          <span>Ressuprimento</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog_ativo = false">
          <v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="mt-5">
          <v-radio-group v-model="todas_categorias">
            <v-radio value="C">
              <template #label>
                <span class="ml-1">Somente a categoria selecionada</span>
              </template>
            </v-radio>

            <v-radio value="D">
              <template #label>
                <span class="ml-1">Todas as categorias do departamento</span>
              </template>
            </v-radio>
          </v-radio-group>

          <TextFieldFormatadorDeValor
            v-model="ressuprimento"
            outlined
            label="Ressuprimento"
            suffix="dias"
            inteiro
            :max-digitos="0"
            :error-messages="RESSUPRIMENTO"
            @focus="$event.target.select()"
            @keypress.enter="alterarTempoRessuprimento()"
          />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="alterarTempoRessuprimento()"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import TextFieldFormatadorDeValor from '../../../utils/TextFieldFormatadorDeValor.vue'
import { alterarTempoRessuprimento } from "../../../../api/compraPorDepartamentos/Categoria"
import { logout } from '../../../../helpers';
import { required, minValue } from "vuelidate/lib/validators";
import {mapGetters} from "vuex";
import {parametros_rota} from "../helpers/ParametrosRota";

export default {
  name: "Ressuprimento",
  mixins: [parametros_rota],
  components: {TextFieldFormatadorDeValor},
  props: {
    coluna: Object,
    detalhamento_categoria: Object,
    categoria: Object
  },
  data() {
    return {
      dialog_ativo: false,
      ressuprimento: 0,
      todas_categorias: 'C'
    };
  },
  validations: {
    ressuprimento: {
      required,
      minValue: minValue(1)
    }
  },
  watch: {
    dialog_ativo(valor) {
      if(valor) {
        this.ressuprimento = this.detalhamento_categoria.ressuprimento_em_dias
      }
    }
  },
  computed: {
    ...mapGetters({
      'callbackAtualizarTabelaCategorias': 'comprasPorDepartamentos/callbackAtualizarTabelaCategorias',
      'callbackAtualizarCardsTotais': 'comprasPorDepartamentos/callbackAtualizarCardsTotais',
      'callbackAtualizarDetalhesCategoria': 'comprasPorDepartamentos/callbackAtualizarDetalhesCategoria',
    }),
    RESSUPRIMENTO() {
      const errors = [];
      if (!this.$v.ressuprimento.$dirty) return errors;
      !this.$v.ressuprimento.required && errors.push("Campo Obrigatório.");
      !this.$v.ressuprimento.minValue && errors.push("Insira um valor inteiro.");
      return errors;
    }
  },
  methods: {
    alterarTempoRessuprimento() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const params = {
        grupo: this.grupo_compra,
        departamento: this.departamento_compra,
        categoria: this.categoria.idcategoria,
        ressuprimento: parseInt(this.ressuprimento),
        flag_categoria: this.todas_categorias,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        alterarTempoRessuprimento(params)
          .then(() => {
            this.dialog_ativo = false;
            this.callbackAtualizarTabelaCategorias();
            this.callbackAtualizarCardsTotais();
            this.callbackAtualizarDetalhesCategoria();
          })
          .catch(logout)
      )
    }
  }
}
</script>

<style>

</style>
